import { Box, Typography } from '@mui/material'
import styled from '@emotion/styled'
import bgFooter from 'assets/png/bg_footer.png'
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk'
import { theme } from 'styles/theme/hav-theme'

export const WrapFooterStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 107px;
  background-image: url('${bgFooter}');
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: 104% 107px;
  text-align: center;

  @media only screen and (max-width: ${theme.breakpoints.sm}px) {
    height: 78px;
    background-size: 104% 78px;
    padding-top: ${theme.spacing.sm};
  }
`

export const WrapPhoneIconStyled = styled(Box)`
  display: flex;
  margin-right: ${theme.spacing.sm};
`

export const PhoneNumberStyled = styled(Typography)`
  color: ${theme.colors.neutral.white};
  font-size: 1.875rem;
  letter-spacing: 0.1rem;
  font-weight: 600;
  margin-bottom: ${theme.spacing.xs};

  @media only screen and (max-width: ${theme.breakpoints.sm}px) {
    font-size: 1.375rem;
  }
`

export const TypographyStyled = styled(Typography)`
  color: ${theme.colors.neutral.white};
  font-size: 0.875rem;
  font-weight: 700;

  @media only screen and (max-width: ${theme.breakpoints.sm}px) {
    font-size: 0.625rem;
  }
`

export const PhoneInTalkIconStyled = styled(PhoneInTalkIcon)`
  font-size: ${theme.icon.size.xx.big};

  @media only screen and (max-width: ${theme.breakpoints.sm}px) {
    font-size: ${theme.icon.size.big};
  }

  path {
    color: ${theme.colors.neutral.white};
  }
`
